import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockTextData {
  text?: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTextData {
  export function make(text?: string, url?: string): BlockTextData {
    return {
      text: text ? BlockComponentText.make(text) : undefined,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(text = 'テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト'): BlockTextData {
    return make(
      `<p>${text}</p>`,
    );
  }
}

export default BlockTextData;
